export const partnerSidebarItems = [
  {
    type: "accordion",
    title: "General",
    content: [
      {
        title: "Dashboard",
        link: "/dashboard",
        tag: "dashboard",
        isLocked: true,
        defaultPermission: "1", // Read Only
      },
      {
        title: "Partner Profile",
        link: "/partner-profile",
        tag: "partnerProfile",
        isLocked: true,
        defaultPermission: "2", // Read & Write
      },
    ],
  },
  {
    type: "accordion",
    title: "Manage Partner Accounts",
    content: [
      {
        title: "Roles and Templates",
        link: "/roles-and-templates",
        isLocked: true,
        tag: "partnerRolesAndTemplates",
        defaultPermission: "2", // Read & Write
      },
      {
        title: "Partner Accounts",
        link: "/partner-accounts",
        isLocked: true,
        tag: "partnerAccounts",
        defaultPermission: "2", // Read & Write
      },
    ],
  },
  {
    type: "accordion",
    title: `Lockers`,
    content: [
      {
        title: `Assign to Branch`,
        link: `/assign-to-branch`,
        tag: `assignToBranch`,
      },
      {
        title: `Assign to Agent`,
        link: `/assign-to-agent`,
        tag: `assignToAgent`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Locker Users`,
    content: [
      {
        title: `View Package History`,
        link: `/view-package-history`,
        tag: `viewPackageHistory`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Agents`,
    content: [
      {
        title: `Agents`,
        link: `/agents`,
        tag: `agents`,
      },
      {
        title: `Agent Affiliation`,
        link: `/agent-affiliation`,
        tag: `agentAffiliation`,
      },
      {
        title: `Batch Upload`,
        link: `/batch-upload`,
        tag: `batchUpload`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Partners`,
    content: [
      {
        title: `Branches`,
        link: `/branches`,
        tag: `branches`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Settings`,
    content: [
      {
        title: `Wallet Top Up`,
        link: `/wallet-top-up`,
        tag: `walletTopUp`,
      },
    ],
  },
  {
    type: "accordion",
    title: `Reports`,
    content: [
      {
        title: `Dropoff Status & History`,
        link: `/drop-off-status`,
        tag: `dropoffStatusHistory`,
      },
      {
        title: `Wallet History Report`,
        link: `/wallet-history-report`,
        tag: `walletHistoryReport`,
      },
      {
        title: `Partner Performance`,
        link: `/partner-performance-report`,
        tag: `partnerBranchPerformance`,
      },
    ],
  },
];
